<template>
   <div class="gens-monogenicdisease">
       <!-- <div class="img-ss">
            <img class="gens-img" src="../../assets/images/headerimg/Header_1920x380_reproductive-health-monogenic-disease.jpg" />
             <h1 class="gens-title">{{$t('ContractText.Detection_diseases')}}</h1>
       </div> -->
       <banner>
            <img src="../../assets/images/headerimg/Header_1920x380_reproductive-health-monogenic-disease.jpg" />
            <div slot="title">{{$t('ContractText.Detection_diseases')}}</div>
        </banner>
       <div class="gens_header_tip">
           <div class="tip_red">{{$t('monogenicdisease.monogenicdisease_1')}}</div>
           <div class="tip_white">{{$t('monogenicdisease.monogenicdisease_2')}}</div>
       </div>

        <div class="gens_result">
               <div class="gens_result_info">
                   <div class="gens_result_info_tip">
                       <div class="result_text">{{$t('monogenicdisease.monogenicdisease_3')}}</div>
                       <div class="result_line"></div>
                   </div>
                  <div class="gens_content_first">
                      <div class="gens_content_first_left">
                         <div class="title_tip">{{$t('monogenicdisease.monogenicdisease_4')}}</div>

                         <div class="title_content">
                             <div class="title_content_imgs">
                                 <img src="../../assets/images/monogenicdisease/monogenic-01.png" />
                             </div>
                            <div class="titel_content_right">{{$t('monogenicdisease.monogenicdisease_5')}} <span class="title_number">1</span></div>
                        </div>
                         <div class="title_content">
                             <div class="title_content_imgs">
                                 <img src="../../assets/images/monogenicdisease/monogenic-02.png" />
                             </div>
                            <div class="titel_content_right"> {{$t('monogenicdisease.monogenicdisease_6')}} <span class="title_number">1</span></div>
                        </div>
                         <div class="title_content">
                             <div class="title_content_imgs">
                                 <img src="../../assets/images/monogenicdisease/monogenic-03.png" />
                             </div>
                            <div class="titel_content_right">{{$t('monogenicdisease.monogenicdisease_7')}}<span class="title_number">2</span></div>
                        </div>
                        <div class="title_content_tip_bottom"><strong>{{$t('monogenicdisease.monogenicdisease_8')}}</strong></div>
                      </div>

                      <div class="gens_content_first_right title_content_special">
                          <div class="gens_content_first_right_img ">
                               <img src="../../assets/images/monogenicdisease/disease-baby.jpg" />
                          </div>
                      </div>
                  </div>
               </div>
        </div>

        <div class="gens_four_content">
            <div class="gens_four_content_info">
                <div class="gens_four_content_tip">
                    <div class="gens_four_content_text">{{$t('monogenicdisease.monogenicdisease_9')}}</div>
                    <div class="gens_four_content_line"></div>
                </div>
                <div class="gens_four_detail">
                    <div class="gens_four_detail_left">
                        <div class="gens_four_item">
                            <i class="icon iconfont icongantanhao gantanhao"></i>
                            <span class="four_detail_tip">{{$t('monogenicdisease.monogenicdisease_10')}}</span>
                        </div>
                        <div class="gens_four_item">
                            <i class="icon iconfont icongantanhao gantanhao"></i>
                            <span class="four_detail_tip">{{$t('monogenicdisease.monogenicdisease_11')}}</span>
                        </div>
                        <div class="gens_four_item">
                            <i class="icon iconfont icongantanhao gantanhao"></i>
                            <span class="four_detail_tip">{{$t('monogenicdisease.monogenicdisease_12')}}</span>
                        </div>
                        <div class="gens_four_item">
                            <i class="icon iconfont icongantanhao gantanhao"></i>
                            <span class="four_detail_tip"> {{$t('monogenicdisease.monogenicdisease_13')}}</span>
                        </div>
                        <div class="gens_four_item">
                            <i class="icon iconfont icongantanhao gantanhao"></i>
                            <span class="four_detail_tip">{{$t('monogenicdisease.monogenicdisease_14')}}</span>
                        </div>
                        <div class="gens_four_item">
                            <i class="icon iconfont icongantanhao gantanhao"></i>
                            <span class="four_detail_tip">{{$t('monogenicdisease.monogenicdisease_15')}}</span>
                        </div>
                    </div>
                    <div class="gend_four_detail_right">
                        <div class="four_detai_img">
                             <img src="../../assets/images/monogenicdisease/death.png" />
                             <div class="right_death">
                                 <i class="icon iconfont icongantanhao gantanhao"></i>
                                 {{$t('monogenicdisease.monogenicdisease_16')}}
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="gens_killer_content">
            <div class="gens_killer_content_info">
                <div class="gens_killer_content_tip">
                    <div class="gens_killer_content_text">{{$t('monogenicdisease.monogenicdisease_17')}}</div>
                    <div class="gens_killer_content_line"></div>
                </div>
                <div class="killer_content">
                    <div class="killer_content_item">
                        <div class="killer_img killer_img_one">
                            <img src="../../assets/images/monogenicdisease/monogenic-autosomal.png" />
                        </div>
                        <div class="killer_tip">{{$t('monogenicdisease.monogenicdisease_18')}}</div>
                        <div class="killer_content" style="flex-direction:column">
                            <div>{{$t('monogenicdisease.monogenicdisease_19')}}</div>
                            <div v-if="$i18n.locale=='en-US'">{{$t('monogenicdisease.monogenicdisease_19s')}}</div>
                        </div>
                       
                    </div>
                    <div class="killer_content_item">
                        <div class="killer_img killer_img_two">
                            <img src="../../assets/images/monogenicdisease/monogenic-x-linked.png" />
                        </div>
                        <div class="killer_tip">{{$t('monogenicdisease.monogenicdisease_20')}}</div>
                        <div class="killer_content" style="flex-direction:column">
                            <div>{{$t('monogenicdisease.monogenicdisease_21')}}</div>
                            <div v-if="$i18n.locale=='en-US'">{{$t('monogenicdisease.monogenicdisease_21s')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="gens_transparent_bk">
            <div class="gens_transparent_bk_content">
                <div class="gens_transparent_bk_tip">
                    {{$t('monogenicdisease.monogenicdisease_22')}}<span class="bk_number"> 3</span>
                </div>
                <div class="gens_transparent_bk_c">{{$t('monogenicdisease.monogenicdisease_23')}}</div>
            </div>
        </div>


          <div class="gens_result special_result">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('monogenicdisease.monogenicdisease_24')}}</div>
                    <div class="result_line"></div>
                </div>
            </div>
            <div class="tip_category">{{$t('monogenicdisease.monogenicdisease_25')}}</div>
            <div class="gens_list">
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-32.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_26')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_27')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_28')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-33.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_29')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_30')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_31')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-34.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_32')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_33')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_34')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-35.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_35')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_36')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_37')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-36.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_38')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_39')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_40')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-37.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_41')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_42')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_43')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-38.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_44')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_45')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_46')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-39.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_47')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_48')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_49')}}</div>
                        </div>
                    </div>
                </div>
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-40.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_50')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_51')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_52')}}</div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="tip_category">{{$t('monogenicdisease.monogenicdisease_53')}}</div>
            <div class="gens_list">
                <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-41.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_54')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_55')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_56')}}</div>
                            
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-42.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_57')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_58')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_59')}}</div>
                        </div>
                    </div>
                </div>
                 <div class="gens_list_item">
                    <div class="gens_list_item_single">
                        <div class="gens_list_item_img">
                            <img  src="../../assets/images/monogenicdisease/Reproductive-health_icon-43.png" />
                        </div>
                        <div class="gens_list_item_content">
                            <div class="gens_list_item_tip">{{$t('monogenicdisease.monogenicdisease_60')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_61')}}</div>
                            <div class="gens_list_item_abstract">{{$t('monogenicdisease.monogenicdisease_62')}}</div>
                        </div>
                    </div>
                </div>
            </div>
         </div>

        <div class="gens_testing_info">
            <div class="gens_testing_info_show">
               <div class="info_show_text">
                   <div v-if="!showInfoDetail" @click="showInfoDetail=true">{{$t('monogenicdisease.monogenicdisease_63')}} <br /> 
                        <div class="info_show_text_icon" >
                            <i class="icon iconfont iconxiala xiala"></i>
                        </div>
                   </div>
                   <div v-if="showInfoDetail"  @click="showInfoDetail=false">{{$t('monogenicdisease.monogenicdisease_64')}} <br />
                         <div class="info_show_text_icon" >
                            <i class="icon iconfont iconarrowtop xiala"></i>
                        </div>
                   </div>
                </div>
           </div>
           <div class="gens_testing_detail" v-if="showInfoDetail">
               <div class="gens_testing_detail_content">
                   <div class="gens_testing_detail_c_item">
                       <ol start="1" v-if="$i18n.locale=='zh-TCC'">
                            <li>α-地中海貧血</li>
                            <li>β-地中海貧血</li>
                            <li>苯丙酮尿症</li>
                            <li>半乳糖血症</li>
                            <li>肝豆狀核變性</li>
                            <li>糖原累積病 II 型</li>
                            <li>脊髓性肌肉萎縮症</li>
                            <li>遺傳性耳聾 1A 型</li>
                            <li>遺傳性耳聾 4 型</li>
                            <li>囊性纖維化</li>
                            <li>脆性X綜合症</li>
                            <li>乙型血友病</li>
                            <li>進行性假肥大性肌營養不良</li>
                            <li>常染色體隱性多囊腎病</li>
                            <li>常染色體隱性耳聾 23 型</li>
                            <li>常染色體隱性耳聾 1F 型</li>
                            <li>常染色體隱性耳聾 3A 型</li>
                            <li>常染色體隱性遺傳沙勒瓦薩格奈痙攣性共濟失調</li>
                            <li>X 連鎖少汗性外胚層發育不良</li>
                            <li>X 連鎖重症聯合免疫缺陷</li>
                            <li>X 連鎖先天性腎上腺發育不全</li>
                            <li>X 連鎖遺傳眼白化病</li>
                            <li>X 連鎖中央核肌病</li>
                            <li>中鏈醯基輔酶 A 脫氫酶缺乏症</li>
                            <li>極長鏈醯基輔酶 A 脫氫酶缺乏症</li>
                            <li>短鏈醯基輔酶 A 脫氫酶缺乏症</li>
                            <li>天冬氨醯葡糖胺尿症</li>
                            <li>α-甘露糖苷貯積症</li>
                            <li>雄激素不敏感綜合征</li>
                            <li>Bloom 綜合征</li>
                            <li>Bjornstad 綜合征</li>
                            <li>CC2D2A 相關性 COACH 綜合征</li>
                            <li>聯合性垂體激素缺乏症 2 型</li>
                            <li>Canavan 病</li>
                        </ol>
                         <ol start="1" v-if="$i18n.locale=='zh-CN'">
                            <li>α-地中海貧血</li>
                            <li>β-地中海贫血</li>
                            <li>苯丙酮尿症</li>
                            <li>半乳糖血症</li>
                            <li>肝豆状核变性</li>
                            <li>糖原累积病 II 型</li>
                            <li>脊髓性肌肉萎缩症</li>
                            <li>遗传性耳聋 1A 型</li>
                            <li>遗传性耳聋 4 型</li>
                            <li>囊性纤维化</li>
                            <li>脆性X综合症</li>
                            <li>乙型血友病</li>
                            <li>进行性假肥大性肌营养不良</li>
                            <li>常染色体隐性多囊肾病</li>
                            <li>常染色体隐性耳聋 23 型</li>
                            <li>常染色体隐性耳聋 1F 型</li>
                            <li>常染色体隐性耳聋 3A 型</li>
                            <li>常染色体隐性遗传沙勒瓦萨格奈痉挛性共济失调</li>
                            <li>X 连锁少汗性外胚层发育不良</li>
                            <li>X 连锁重症联合免疫缺陷</li>
                            <li>X 连锁先天性肾上腺发育不全</li>
                            <li>X 连锁遗传眼白化病</li>
                            <li>X 连锁中央核肌病</li>
                            <li>中链醯基辅酶 A 脱氢酶缺乏症</li>
                            <li>极长链醯基辅酶 A 脱氢酶缺乏症</li>
                            <li>短链醯基辅酶 A 脱氢酶缺乏症</li>
                            <li>天冬氨醯葡糖胺尿症</li>
                            <li>α-甘露糖苷贮积症</li>
                            <li>雄激素不敏感综合征</li>
                            <li>Bloom 综合征</li>
                            <li>Bjornstad 综合征</li>
                            <li>CC2D2A 相关性 COACH 综合征</li>
                            <li>联合性垂体激素缺乏症 2 型</li>
                            <li>Canavan 病</li>
                        </ol>
                    <ol start="1" v-if="$i18n.locale=='en-US'">
                            <li>Alpha-thalassemia</li>
                            <li>Beta-thalassemia</li>
                            <li>Phenylketonuria</li>
                            <li>Galactosemia</li>
                            <li>Wilson Disease</li>
                            <li>Glycogen Storage Disease Type II</li>
                            <li>Spinal Muscular Atrophy</li>
                            <li>Autosomal Recessive Deafness 1A</li>
                            <li>Autosomal Recessive Deafness 4, with Enlarged Vestibular Aqueduct</li>
                            <li>Cystic Fibrosis</li>
                            <li>Fragile X Syndrome</li>
                            <li>Hemophilia B</li>
                            <li>Duchenne Muscular Dystrophy</li>
                            <li>Autosomal Recessive Polycystic Kidney Disease</li>
                            <li>Autosomal Recessive Deafness 23</li>
                            <li>Usher Syndrome Type 1F</li>
                            <li>Usher Syndrome Type 3A</li>
                            <li>Autosomal Recessive Spastic Ataxia of Charlevoix-Saguenay</li>
                            <li>X-Linked Hypohidrotic Ectodermal Dysplasia</li>
                            <li>X-Linked Severe Combined Immunodeficiency</li>
                            <li>X-Linked Adrenal Hypoplasia Congenita</li>
                            <li>X-Linked Ocular Albinism</li>
                            <li>X-Linked Centronuclear Myopathy</li>
                            <li>Acyl-CoA Dehydrogenase Deficiency, Medium-Chain</li>
                            <li>Acyl-CoA Dehydrogenase Deficiency, Very Long-Chain</li>
                            <li>Acyl-CoA Dehydrogenase Deficiency, Short-Chain</li>
                            <li>Aspartylglucosaminuria</li>
                            <li>Alpha-Mannosidosis</li>
                            <li>Androgen Insensitivity Syndrome</li>
                            <li>Bloom syndrome</li>
                            <li>Bjornstad Syndrome</li>
                            <li>CC2D2A-Related COACH Syndrome</li>
                            <li>Combined pituitary hormone deficiency 2</li>
                            <li>Canavan Disease</li>
                        </ol>
                   
                   </div>
                   <div class="gens_testing_detail_c_item">
                       <ol start="35" v-if="$i18n.locale=='zh-TCC'">
                            <li>Ellis-van Creveld 綜合征</li>
                            <li>家族性自主神經失調</li>
                            <li>Fanconi 貧血，互補群 A</li>
                            <li>Fanconi 貧血，互補群 C</li>
                            <li>Fabry 病</li>
                            <li>GRACILE 綜合征</li>
                            <li>戊二酸血症 I 型</li>
                            <li>糖原累積病 Ia 型</li>
                            <li>糖原累積病 Ib 型</li>
                            <li>Hermansky-Pudlak 綜合症 1 型</li>
                            <li>Hermansky-Pudlak 綜合症 3 型</li>
                            <li>家族性噬血細胞性淋巴組織細胞增多症 2 型</li>
                            <li>家族性噬血細胞性淋巴組織細胞增多症 3 型</li>
                            <li>家族性噬血細胞性淋巴組織細胞增多症 4 型</li>
                            <li>家族性噬血細胞性淋巴組織細胞增多症 5 型</li>
                            <li>遺傳性運動和感覺神經病變伴胼胝體發育不全</li>
                            <li>高鳥氨酸血症-高氨血症-同型瓜氨酸尿症</li>
                            <li>遺傳性果糖不耐受症</li>
                            <li>Joubert 綜合征 2 型</li>
                            <li>Joubert 綜合征 3 型</li>
                            <li>Joubert 綜合征 5 型</li>
                            <li>Joubert 綜合征 6 型</li>
                            <li>Joubert 綜合征 9 型</li>
                            <li>楓糖尿病 1A 型</li>
                            <li>楓糖尿病 1B 型</li>
                            <li>楓糖尿病 3 型</li>
                            <li>甲基丙二酸血症 Mut 型</li>
                            <li>甲基丙二酸血症 cblA 型</li>
                            <li>甲基丙二酸血症 cblB 型</li>
                            <li>甲基丙二酸血症伴同型半胱氨酸血症 cblC 型</li>
                            <li>甲基丙二酸血症伴同型半胱氨酸血症 cblD 型</li>
                            <li>甲基丙二酸單醯輔酶 A 異構酶缺乏症</li>
                            <li>黏多糖貯積症 IIIA 型</li>
                            <li>黏多糖貯積症 IIIB 型</li>
                        </ol>
                   
                        <ol start="35" v-if="$i18n.locale=='zh-CN'">
                                <li>Ellis-van Creveld 综合征</li>
                                <li>家族性自主神经失调</li>
                                <li>Fanconi 贫血，互补群 A</li>
                                <li>Fanconi 贫血，互补群 C</li>
                                <li>Fabry 病</li>
                                <li>GRACILE 综合征</li>
                                <li>戊二酸血症 I 型</li>
                                <li>糖原累积病 Ia 型</li>
                                <li>糖原累积病 Ib 型</li>
                                <li>Hermansky-Pudlak 综合症 1 型</li>
                                <li>Hermansky-Pudlak 综合症 3 型</li>
                                <li>家族性噬血细胞性淋巴组织细胞增多症 2 型</li>
                                <li>家族性噬血细胞性淋巴组织细胞增多症 3 型</li>
                                <li>家族性噬血细胞性淋巴组织细胞增多症 4 型</li>
                                <li>家族性噬血细胞性淋巴组织细胞增多症 5 型</li>
                                <li>遗传性运动和感觉神经病变伴胼胝体发育不全</li>
                                <li>高鸟氨酸血症-高氨血症-同型瓜氨酸尿症</li>
                                <li>遗传性果糖不耐受症</li>
                                <li>Joubert 综合征 2 型</li>
                                <li>Joubert 综合征 3 型</li>
                                <li>Joubert 综合征 5 型</li>
                                <li>Joubert 综合征 6 型</li>
                                <li>Joubert 综合征 9 型</li>
                                <li>枫糖尿病 1A 型</li>
                                <li>枫糖尿病 1B 型</li>
                                <li>枫糖尿病 3 型</li>
                                <li>甲基丙二酸血症 Mut 型</li>
                                <li>甲基丙二酸血症 cblA 型</li>
                                <li>甲基丙二酸血症 cblB 型</li>
                                <li>甲基丙二酸血症伴同型半胱氨酸血症 cblC 型</li>
                                <li>甲基丙二酸血症伴同型半胱氨酸血症 cblD 型</li>
                                <li>甲基丙二酸单醯辅酶 A 异构酶缺乏症</li>
                                <li>黏多糖贮积症 IIIA 型</li>
                                <li>黏多糖贮积症 IIIB 型</li>
                        </ol>
                         <ol start="35" v-if="$i18n.locale=='en-US'">
                           <li>Ellis-van Creveld Syndrome</li>
                            <li>Familial Dysautonomia</li>
                            <li>Fanconi anemia, complementation group A</li>
                            <li>Fanconi anemia, complementation group C</li>
                            <li>Fabry Disease</li>
                            <li>GRACILE Syndrome</li>
                            <li>Glutaric Acidemia I</li>
                            <li>Glycogen Storage Disease Type Ia</li>
                            <li>Glycogen Storage Disease Type Ib/Ic</li>
                            <li>Hermansky-Pudlak Syndrome 1</li>
                            <li>Hermansky-Pudlak Syndrome 3</li>
                            <li>Hemophagocytic lymphohistiocytosis, familial, 2</li>
                            <li>Hemophagocytic lymphohistiocytosis, familial, 3</li>
                            <li>Hemophagocytic lymphohistiocytosis, familial, 4</li>
                            <li>Hemophagocytic lymphohistiocytosis, familial, 5</li>
                            <li>Hereditary Motor and Sensory Neuropathy with Agenesis of the Corpus Callosum</li>
                            <li>Hyperornithinemia-Hyperammonemia-Homocitrullinuria Syndrome</li>
                            <li>Hereditary Fructose Intolerance ALDOB</li>
                            <li>Joubert Syndrome 2</li>
                            <li>Joubert Syndrome 3</li>
                            <li>Joubert Syndrome 5</li>
                            <li>Joubert Syndrome 6</li>
                            <li>Joubert Syndrome 9</li>
                            <li>Maple Syrup Urine Disease Type 1A</li>
                            <li>Maple Syrup Urine Disease Type 1B</li>
                            <li>Maple Syrup Urine Disease Type 3</li>
                            <li>MUT-Related Methylmalonic Acidemia</li>
                            <li>MMAA-Related Methylmalonic Acidemia</li>
                            <li>MMAB-Related Methylmalonic Acidemia</li>
                            <li>Methylmalonic Aciduria and Homocystinuria CblC type</li>
                            <li>Methylmalonic Aciduria and Homocystinuria CblD type</li>
                            <li>MCEE-Related Methylmalonic Acidemia</li>
                            <li>Mucopolysaccharidosis Type IIIA</li>
                            <li>Mucopolysaccharidosis Type IIIB</li>
                        </ol>
                   
                   
                   </div>
                   <div class="gens_testing_detail_c_item">
                       <ol start="69" v-if="$i18n.locale=='zh-TCC'">
                            <li>線粒體複合物 3 缺乏症核 1 型</li>
                            <li>異染性腦白質營養不良</li>
                            <li>Meckel 綜合征 2 型</li>
                            <li>Meckel 綜合征 3 型</li>
                            <li>Meckel 綜合征 4 型</li>
                            <li>神經元蠟樣脂褐質沉積症 1 型</li>
                            <li>神經元蠟樣脂褐質沉積症 2 型</li>
                            <li>神經元蠟樣脂褐質沉積症 3 型</li>
                            <li>神經元蠟樣脂褐質沉積症 4A 型</li>
                            <li>神經元蠟樣脂褐質沉積症 5 型</li>
                            <li>神經元蠟樣脂褐質沉積症 6 型</li>
                            <li>神經元蠟樣脂褐質沉積症 7 型</li>
                            <li>Niemann-Pick 病 A 型</li>
                            <li>Niemann-Pick 病 B 型</li>
                            <li>Niemann-Pick 病 C1 型</li>
                            <li>Niemann-Pick 病 C2 型</li>
                            <li>腎病綜合征 1 型</li>
                            <li>腎消耗病 11 型</li>
                            <li>腎病型胱氨酸症</li>
                            <li>眼皮膚白化病 1 型</li>
                            <li>眼皮膚白化病 2 型</li>
                            <li>眼皮膚白化病 3 型</li>
                            <li>眼皮膚白化病 4 型</li>
                            <li>眼皮膚白化病 6 型</li>
                            <li>眼皮膚白化病 7 型</li>
                            <li>進行性家族性肝內膽汁淤積 2 型</li>
                            <li>Smith-Lemli-Opitz 綜合征</li>
                            <li>鐮狀細胞性貧血症</li>
                            <li>Sjogren-Larsson 綜合征</li>
                            <li>Tay-Sachs 病</li>
                            <li>TMEM67 相關性 COACH 綜合征</li>
                            <li>四氫生物喋呤缺乏症</li>
                            <li>酪氨酸血症 I 型</li>
                        </ol>
                        <ol start="69" v-if="$i18n.locale=='zh-CN'">
                            <li>线粒体复合物 3 缺乏症核 1 型</li>
                            <li>异染性脑白质营养不良</li>
                            <li>Meckel 综合征 2 型</li>
                            <li>Meckel 综合征 3 型</li>
                            <li>Meckel 综合征 4 型</li>
                            <li>神经元蜡样脂褐质沉积症 1 型</li>
                            <li>神经元蜡样脂褐质沉积症 2 型</li>
                            <li>神经元蜡样脂褐质沉积症 3 型</li>
                            <li>神经元蜡样脂褐质沉积症 4A 型</li>
                            <li>神经元蜡样脂褐质沉积症 5 型</li>
                            <li>神经元蜡样脂褐质沉积症 6 型</li>
                            <li>神经元蜡样脂褐质沉积症 7 型</li>
                            <li>Niemann-Pick 病 A 型</li>
                            <li>Niemann-Pick 病 B 型</li>
                            <li>Niemann-Pick 病 C1 型</li>
                            <li>Niemann-Pick 病 C2 型</li>
                            <li>肾病综合征 1 型</li>
                            <li>肾消耗病 11 型</li>
                            <li>肾病型胱氨酸症</li>
                            <li>眼皮肤白化病 1 型</li>
                            <li>眼皮肤白化病 2 型</li>
                            <li>眼皮肤白化病 3 型</li>
                            <li>眼皮肤白化病 4 型</li>
                            <li>眼皮肤白化病 6 型</li>
                            <li>眼皮肤白化病 7 型</li>
                            <li>进行性家族性肝内胆汁淤积 2 型</li>
                            <li>Smith-Lemli-Opitz 综合征</li>
                            <li>镰状细胞性贫血症</li>
                            <li>Sjogren-Larsson 综合征</li>
                            <li>Tay-Sachs 病</li>
                            <li>TMEM67 相关性 COACH 综合征</li>
                            <li>四氢生物喋呤缺乏症</li>
                            <li>酪氨酸血症 I 型</li>
                        </ol>
                        <ol start="69" v-if="$i18n.locale=='en-US'">
                            <li>Mitochondrial Complex III Deficiency Nuclear Type 1</li>
                            <li>Metachromatic Leukodystrophy due to Arylsulfatase A</li>
                            <li>Meckel Syndrome 2</li>
                            <li>Meckel Syndrome 3</li>
                            <li>Meckel Syndrome 4</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 1</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 2</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 3</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 4A</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 5</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 6</li>
                            <li>Neuronal Ceroid-Lipofuscinoses 7</li>
                            <li>Niemann-Pick Disease Type A</li>
                            <li>Niemann-Pick Disease Type B</li>
                            <li>Niemann-Pick Disease Type C1</li>
                            <li>Niemann-Pick Disease Type C2</li>
                            <li>Nephrotic syndrome, Type 1</li>
                            <li>Nephronophthisis 11</li>
                            <li>Nephropathic Cystinosis</li>
                            <li>Oculocutaneous Albinism Type 1</li>
                            <li>Oculocutaneous Albinism Type 2</li>
                            <li>Oculocutaneous Albinism Type 3</li>
                            <li>Oculocutaneous Albinism Type 4</li>
                            <li>Oculocutaneous Albinism Type 6</li>
                            <li>Oculocutaneous Albinism Type 7</li>
                            <li>Progressive Familial Intrahepatic Cholestasis: Type 2</li>
                            <li>Smith-Lemli-Opitz syndrome</li>
                            <li>Sickle Cell Anemia</li>
                            <li>Sjogren-Larsson syndrome</li>
                            <li>Tay-Sachs Disease</li>
                            <li>TMEM67-Related COACH Syndrome</li>
                            <li>Tetrahydrobiopterin (BH4)-deficient PTS hyperphenylalaninemia (HPA)</li>
                            <li>Tyrosinemia Type I</li>
                        </ol>
                   </div>
               </div>
           </div>
        </div>


        <div class="gens_result special_result science_top">
            <div class="gens_result_info">
                <div class="gens_result_info_tip">
                    <div class="result_text">{{$t('monogenicdisease.monogenicdisease_65')}}</div>
                    <div class="result_line"></div>
                </div>
                <div class="gens_result_science" >
                       <div class="science_item science_item_special science_item_special_std" id="science_one">
                           <div class="science_item_img" >
                               <img class="img_science img_science_specials"  src="../../assets/images/monogenicdisease/Reproductive-health_icon-01.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_content ab_special">{{$t('monogenicdisease.monogenicdisease_66')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std" id="science_two">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials"  src="../../assets/images/monogenicdisease/Reproductive-health_icon-02.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_content ab_special">{{$t('monogenicdisease.monogenicdisease_67')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std" id="science_three">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials"  src="../../assets/images/monogenicdisease/Reproductive-health_icon-03.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_content ab_special">{{$t('monogenicdisease.monogenicdisease_68')}}</div>
                           </div>
                       </div>
                       <div class="science_item science_item_special science_item_special_std" id="science_four">
                           <div class="science_item_img">
                               <img class="img_science img_science_specials"  src="../../assets/images/monogenicdisease/Reproductive-health_icon-04.png" alt />   
                           </div>
                           <div class="science_abstract">
                               <div class="abstract_content ab_special">{{$t('monogenicdisease.monogenicdisease_69')}}</div>
                           </div>
                       </div>
                       
                   </div>
            </div>
         </div>


         <div class="gens_example_analysis">
            <div class="gens_example_analysis_info">
                <div class="gens_example_analysis_info_tip">
                    <div class="gens_example_analysis_text">{{$t('monogenicdisease.monogenicdisease_70')}}</div>
                    <div class="gens_example_analysis_line"></div>
                </div>
                <div class="gens_analysis_content">
                    <div class="gens_analysis_left">
                         <div class="gens_example_single">{{$t('monogenicdisease.monogenicdisease_71')}}</div>
                         <div class="gens_example_advice">{{$t('monogenicdisease.monogenicdisease_72')}}</div>
                         <div class="gens_example_advice">{{$t('monogenicdisease.monogenicdisease_73')}}<strong>{{$t('monogenicdisease.monogenicdisease_s')}}</strong></div>
                         <div class="for_example">
                             <i class="icon iconfont iconyinhao yinhaos"></i>
                             <div class="for_example_content">{{$t('monogenicdisease.monogenicdisease_74')}}</div>
                         </div>
                    </div>
                    <div class="gens_analysis_right">
                        <div class="gens_analysis_right_img">
                            <img src="../../assets/images/monogenicdisease/monogenic-case.png" />
                        </div>
                    </div>
                </div>
               
            </div>
        </div>       
        
       

        <div class="gens_last_bottom special_result">
            <div class="gens_last_bottom_content">
                <div class="gens_last_bottom_content_tip">{{$t('monogenicdisease.monogenicdisease_75')}}</div>
                <div class="gens_last_bottom_content_tip_line"></div>
                <div class="gens_last_abstract">
                    <span class="abstract_stip"> {{$t('monogenicdisease.monogenicdisease_76')}}  </span>
                    <span class="abstract_content">{{$t('monogenicdisease.monogenicdisease_77')}}</span>
                </div>
                <div class="gens_last_abstract">
                    <span class="abstract_stip abstract_stip_special" :class="$i18n.locale=='en-US'?'specialabstract_stip ':''">  {{$t('monogenicdisease.monogenicdisease_78')}}  </span>
                    <span class="abstract_content" >{{$t('monogenicdisease.monogenicdisease_79')}}</span>
                </div>
                <div class="bottom_document_tip">{{$t('monogenicdisease.monogenicdisease_80')}}</div>
                <div class="bottom_document_cont">1. Control of hereditary disorders: Report of WHO Scientific meeting (1996).</div>
                <div class="bottom_document_cont">2. Hadjivasiliou A, Gardner J. Orphan drug report 2014. 2016.</div>
                <div class="bottom_document_cont bottom_document_cont_last">3. Committee on Genetics. Committee Opinion No. 691: Carrier screening for genetic conditions. Obstet Gynecol. 129.3 (2017): e41-e55.</div>
            </div>
        </div>
   
   </div>
</template>
<script>
import banner from '@/components/banner'
export default {
    data(){
        return{
           showInfoDetail:false,
        }
    },
    
    components: {
      banner,
     
    },
    mounted(){
        $(window).scroll(function(){ //滚动某位置 动画特效
            var box = document.querySelector(".gens_content_first_right_img");
            if( box!=null&&$(window).scrollTop()>(box.offsetTop - box.offsetHeight)){
                $('.gens_content_first_right_img').addClass('opacity');//这里840代表要动画的元素离最顶层的距离，console.log一下就知道了。
                $('.gens_content_first_right_img').addClass('rightturnleft');
            }
            // var box_one= document.querySelector(".img_img_left");
            // if($(window).scrollTop() > (box_one.offsetTop - box_one.offsetHeight)){
            //     $('.img_img_right').addClass('opacity');
            //     $('.text_left_content').addClass('opacity');
            //     $('.text_right_content').addClass('opacity');
            //     $('.img_img_left').addClass('opacity');
                
            // }
            // var box_two= document.querySelector(".science_item_img");
            // if($(window).scrollTop() > (box_two.offsetTop - box_two.offsetHeight)){
            //     $('.science_item_img').addClass('opacity');
            // }
            var box_three= document.querySelector(".people_tops");
            if( box_three!=null&&$(window).scrollTop() > (box_three.offsetTop - box_three.offsetHeight)){
                $('.info_left_img_item').addClass('opacity');
                $('#one').addClass('one_transfer');
                $('#two').addClass('two_transfer');
                $('#three').addClass('three_transfer');


                $('.info_right_img_info').addClass('opacity');
                $('.info_right_img_info').addClass('four_transfer');
                
            }
            // var box_four= document.querySelector(".gens_content_img");
            // if($(window).scrollTop() > (box_four.offsetTop - box_four.offsetHeight)){
            //     $('.gens_content_img').addClass('opacity');
            // }
            var box_five= document.querySelector(".science_top");
            if( box_five!=null&&($(window).scrollTop()) > (box_five.offsetTop - box_five.offsetHeight)){
                $('#science_one').addClass('one_transfer');
                $('#science_two').addClass('two_transfer');
                $('#science_three').addClass('three_transfer');
                $('#science_four').addClass('four_transfer');

            }

            var box_six=document.querySelector(".gens_killer_content");
            if(box_six!=null&&($(window).scrollTop()) > (box_six.offsetTop - box_six.offsetHeight)){
                 $('.killer_img_one').addClass('opacity');
                 $('.killer_img_one').addClass('one_transfer');
                 $('.killer_img_two').addClass('rightturnleft');

            }
            
            
        })
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>

  @import '../../assets/font/iconfont.css';
 @import '../../assets/css/animation.css';
.gens-monogenicdisease{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    

    .img-ss{
        position: relative;
        // display: flex;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                   top:0;
                    width:100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: 600;
            }
    }
    .gens_header_tip{
        background-color: #e699b2;
        padding-top:30px;
        padding-bottom:30px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip_red{
            text-align: center;
            color: #cb3439;
            text-shadow: 1px 1px 2px #ffffff;
            font-size: 28px;
            font-style: normal;
            font-weight: 700;
            text-transform: none;
            line-height: 1.384615384615385em;
        }
        .tip_white{
            text-align: center;
            color: #ffffff;
            text-shadow: 1px 1px 2px #cb3439;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            text-transform: none;
            margin-top:24px;
            line-height: 1.571428571428571em;
        }
    }

    .gens_result{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_info{
             width:1200px;
             margin:auto;
             .gens_result_info_tip{
                 .result_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .result_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .result_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
                 .tip_img{
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        .tip_img_s{
                            height: auto;
                            max-width: 100%;
                            width: 300px;
                        }
                 }
                 .tip_text_sk{
                     color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    margin-bottom:30px;
                 }
             }
            
            .gens_transparent_content_info{
                margin-bottom: 10px;
               
                .mytick{
                    color: #244b6b;;
                    background: 0 0;
                    border: 0;
                    font-size: 18px;
                    height: 16px;
                    width: 16px;
                    display: inline-block;
                    position: relative;
                    border:2px solid #244b6b;;
                }
                .mytick:before,.mytick:after {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    color: #244b6b;;
                    border: 2px solid #244b6b;;
                    background-color: white;
                }
                .mytick:before {
                    width: 1px;
                    height: 0px;
                    left: 18%;
                    top: 46%;
                    transform: skew(0deg, 50deg);
                }
                .mytick:after {
                    width: 11px;
                    height: 0px;
                    left: 38%;
                    top: 15%;
                    transform: skew(0deg, -50deg);
                }

                .tick_text{
                    line-height: 27px;
                    font-weight: 400;
                    margin: 0 0 0px;
                    padding: 0 0 0 18px;
                    position: relative;
                    color: #3a3a3a;
                    font-size: 16px;
                    margin-bottom: -12px;
                }
            }
             .gens_content_first{
                
                 display: flex;
                 justify-content: flex-start;
                 flex-direction: row;
                 margin-bottom:30px;
                 
                 .gens_content_first_left{
                        width:66.66%;
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:30px;
                        margin-right: 30px;
                        .title_tip{
                            margin-bottom:30px;
                        }
                        .title_content{
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            margin-bottom: 20px;
                            align-items: center;
                            .title_content_imgs{
                                display: inline-block;
                                position: relative;
                                z-index: 2;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width:130px;
                                }
                            }
                            .titel_content_right{
                                margin-left:20px;
                                text-align: left;
                                width:590px;
                                .title_number{
                                    font-size: .5em;
                                    vertical-align: super;
                                }
                            }

                        }
                         .title_content_tip_bottom{
                                color: #cb3439 !important;
                                font-size: 20px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.375em;
                                letter-spacing: .07em!important;
                                
                        }
                        .title_content_special{
                            margin-left:-80px !important;
                        }
                 }
                 .gens_content_first_right{
                     width:33.33%;
                     .gens_content_first_right_img{
                         opacity: 0;
                         margin-top:3%;
                         display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                       
                         img{
                             height: auto;
                             max-width: 100%;
                             width:600px;
                         }
                     }
                     
                 }
             }

            .gens_result_info_imgs{
                // margin-bottom:30px;
                // display: inline-block;
                // vertical-align: top;
                // max-width: 100%;
                // img{
                //     vertical-align: middle;
                //     height: auto;
                //     max-width: 100%;
                // }
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                width:86%;
                .gens_result_info_left_img{
                    width:50%;
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: column;
                    .info_left_img_item{
                        padding-bottom: 10px!important;
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        opacity:0;
                        img{
                            height: auto;
                            max-width: 100%;
                            width: 731px;
                        }
                    }
                    
                    
                }
                .gens_result_info_right_img{
                    width:50%;
                    display: flex;
                    justify-items: center;
                    text-align: center;
                    .info_right_img_info{
                        width:100%;
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        opacity: 0;
                            .right_imgs{
                                display: inline-block;
                                vertical-align: top;
                                max-width: 100%;
                                position: absolute;
                            img{
                                height: auto;
                                max-width: 100%;
                                vertical-align: middle;
                                width: 417px;
                            }
                        }
                    }
                    .four_transfer{
                         animation-duration: 2s !important;
                        -webkit-animation-duration:2s !important;
                        animation-fill-mode: both !important;
                        -webkit-animation-fill-mode: both !important;
                        transition-delay: 2s;
                        animation-delay: 2s;
                        animation: fadeInUpLeft  .7s 1 ease-in-out;
                    }
                }
                
            }

            .gens_result_science{
                  display:flex;
                  justify-content: left;
                  flex-direction: row;
                  width: 80%;
                  padding-bottom:30px;
                  padding-top:30px;
                 .science_item{
                    width:25%;
                    text-align: left;
                    .science_item_img{
                        display: grid;
                        justify-content: center;
                        width: 100%;
                        position: relative;

                        -webkit-transition: opacity .8s ease 0s;
                        
                        transition-delay: .4s;
                        .img_science{
                            display: block;
                            margin: 0 0 15px ;
                            max-width: 100%;
                            height: auto;
                        }
                        .img_science_special{
                            width:150px !important;
                        }
                        
                    }
                    .science_item_img_one{
                        transition-delay: .2s;
                    }
                    .science_item_img_two{
                        transition-delay: .4s;
                    }
                    .science_item_img_three{
                        transition-delay: .6s;
                    }
                    .science_item_img_four{
                        transition-delay: .8s;
                    }

                    hr{
                            color: #9a9a9a;
                            display: block;
                            unicode-bidi: isolate;
                            margin-block-start: 0.5em;
                            margin-block-end: 0.5em;
                            margin-inline-start: auto;
                            margin-inline-end: auto;
                            overflow: hidden;
                            border-style: inset;
                            border-width: 1px;
                            border-top: 1px solid #9a9a9a !important;
                        }
                    .science_tip{
                        color: #ef682f;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: 1.304347826086957em;
                        text-transform: none;
                        letter-spacing: 1px;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                    }
                    .science_abstract{
                         margin: 5px 0px 6px 0px;
                        .abstract_tip{
                            color:#244b6b;
                            font-size:18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            letter-spacing: 1px;
                        }
                        .abstract_tip_special{
                            font-size:24px !important;
                        }
                        .ab_special{
                            text-align: center;
                        }
                        .abstract_line{

                        }
                        .abstract_content_one{
                            ul{
                                list-style-position: inside;
                                line-height: 27px;
                                letter-spacing: .07em!important;
                                color: #3b3b3b;
                                font-weight: 400;
                                font-size: 16px;
                                padding-inline-start: 0px !important;
                            }
                        }
                        .number{
                            font-size: .5em;
                            vertical-align: super;
                        }
                        .abstract_content{
                            color: #3a3a3a;
                            font-size: 16px;
                            line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                            letter-spacing: .07em!important;
                            margin-top: 24px;
                        }
                    }

                 }
                 #science_one,#science_two,#science_three,#science_four{
                     opacity: 0;
                 }
                 .science_item_special{
                    padding-left: 15px;
                    padding-right: 16px;
                }
                .science_item_special_std{
                    width:25% !important;
                    .img_science_specials{
                            width:130px !important;
                    }
                }
             }

             .gens_result_science_special{
                 width:85% !important;
             }
             

        }
        .tip_category{
            width:1200px;
            margin:auto;
            margin-bottom:15px;
            color: #e699b2;
            font-size: 20px;
            line-height: 24px;
            font-style: normal;
            font-weight: bold;
            letter-spacing: 0.07em !important;
        }
         .gens_list{

             display:flex;
             width:1200px;
             margin:auto;
             justify-content: flex-start;
             text-align: left;
             flex-direction: row;
             flex-wrap: wrap;
             margin-bottom:30px;
             .gens_list_item{
                 width:33.33%;
                 display: flex;
                 flex-direction: column;
                 .gens_list_item_single{
                     display:flex;
                     flex-direction: row;
                     margin-bottom:18px;
                    .gens_list_item_img{
                        display: inline-block;
                        position: relative;
                        z-index: 2;
                        img{
                            height: auto;
                            width:52px;
                        }
                    }
                    .gens_list_item_content{
                        padding: 0 0 0 20px;
                        .gens_list_item_tip{
                            color: #cb3439;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            line-height: 1.571428571428571em;
                                                    
                            letter-spacing: 1px;
                        }
                        .gens_list_item_abstract{
                            font-size: 14px;
                            line-height: 24px;
                            color: #3a3a3a;
                            font-style: normal;
                            font-weight: 400;
                        }
                    }
                 }
             }
         }
         
    }
    .science_top{

    }

    .gens_result_people{
        background-color: rgba(207,213,227,0.2) !important;
    }
    .people_tops{

    }
   
   
    .gens_result_second{
         background-color: rgba(192,227,221,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_result_second_info{
             width:1200px;
             margin:auto;
             .gens_result_second_info_tip{
                 .gens_result_second_text{
                    color: #5ec3b5;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_result_second_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #5ec3b5;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
                 .gens_result_second_img_tip{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                    margin-block-start: 1em;
                    margin-block-end: 1em;
                    margin-inline-start: 0px;
                    margin-inline-end: 0px;             
                 }
               
             }

             .gens_result_second_content{
                 text-align: center;
                 .content_info{
                     display:flex;
                     justify-content: center;
                     align-items: center;
                     flex-direction: column;
                     .content_info_item{
                         width:1200px;
                         display: flex;
                         justify-content: center;
                         flex-direction: row;
                         .text_left{
                             padding:0 60px;
                             width:50%;
                             .text_left_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: right;
                             }
                             .text_left_content{
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: right;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }
                         .line_down{
                             display:flex;
                             flex-direction: column;
                             justify-content: center;
                             width: 20px;
                             padding-top:60px;
                             position: relative;
                             .circle{
                                 position:absolute;
                                background: #fff;
                                background-color: #5ec3b5;
                                box-sizing: border-box;
                                border: 1px solid transparent;
                                border-radius: 50%;
                                content: "";
                                height: 18px;
                                left: 50%;
                                margin: 0 0 0 -9px;
                                position: absolute;
                                top:20px;
                                width: 18px;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.68) .5s;

                             }
                             .vertical{
                                background-color: #5ec3b5;
                                height: 100%;
                                left: 50%;
                                margin-left: -1px;
                                position: absolute;
                                width: 2px;
                             }
                         }
                         .img_right{
                             width:50%;
                             margin-left:-10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_right{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: left;
                                box-sizing: border-box;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                             
                         }
                         .img_left{
                             width:50%;
                             margin-left:10px;
                             display:flex;
                             align-items: center;
                             padding-top:20px;
                             .img_img_left{
                                opacity: 0;
                                transform: scale(1);
                                transition: transform .6s cubic-bezier(.18,.89,.32,1.28) , opacity .3s ease-out;
                                text-align: right;
                                box-sizing: border-box;
                                margin-right:-10px;
                                img{
                                    max-width: 100%;
                                    height: auto;
                                    width: 1522px;
                                }
                             }
                         }
                           .text_right{
                             width:50%;
                             text-align: left;
                             padding:0 0px;
                             .text_right_tip{
                                color: #15867d;
                                font-size: 24px;
                                font-style: normal;
                                font-weight: 600;
                                text-transform: none;
                                line-height: 1.304347826086957em;
                                letter-spacing: 1px;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;
                                text-align: left;
                                padding-left:60px;
                             }
                            .text_right_content{
                                width:100%;
                                padding-left:60px;
                                color: #3a3a3a;
                                font-size: 16px;
                                line-height: 24px;
                                font-style: normal;
                                font-weight: 400;
                                opacity: 0;
                                transition: opacity .5s cubic-bezier(.22,.61,.36,1) .2s;
                                margin-top: 25px;
                                text-align: left;
                                display: block;
                                margin-block-start: 1em;
                                margin-block-end: 1em;
                                margin-inline-start: 0px;
                                margin-inline-end: 0px;

                        
                             }
                         }

                     }
                 }
             }
        }
    }
    

    .gens_advice{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         
        .gens_content{
            width:1200px;
            margin:auto;
            display: flex;
            justify-content: left;
            flex-direction: row;

            .gens_content_left{
                width:66.66%;
                padding-right:15px;
                .left_tips{
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    color: #5ec3b5;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                    margin-bottom:24px;

                }
                .left_advice_content{
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
            }
            .gens_content_right{
                width:33.33%;
                display: inline-block;
                vertical-align: top;
                max-width: 100%;
                .gens_content_img{
                    animation: element-from-right .7s 1 ease-in-out;
                    opacity: 0;
                    img{
                        height: auto;
                        max-width: 100%;
                    }
                }
            }
        }
    }
    
    .gens_last_bottom{
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
        .gens_last_bottom_content{
            width:1200px;
            margin:auto;
            text-align: left;

            .gens_last_bottom_content_tip{
               color: #e699b2;;
               font-size: 28px;
               font-style: normal;
               font-weight: 700;
               text-transform: none;
               line-height: 1.384615384615385em;
               letter-spacing: 1px;
               margin-top:60px;
            }
            .gens_last_bottom_content_tip_line{
                margin-top: 10px;
                margin-bottom: 30px;
                background-color: #e699b2;;
                width: 250px;
                height: 2px;
                position: relative;

            }
            .gens_last_abstract{
                .abstract_stip{
                    font-size: 18px;
                    color: #fff;
                    font-weight: bold;
                    background-color: #00b0c0;
                    padding:0 10px;
                }
                .abstract_stip_special{
                    background-color: #e699b2 !important;
                }
                .abstract_content{
                    font-size: 16px;
                    padding-left:5px;
                }
            }
           
            .bottom_document_tip{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                margin-top:30px;
            }
            .bottom_document_cont{
                font-size: 12px;
                color: #3a3a3a;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                
            }
            .bottom_document_cont_last{
                margin-bottom:60px;
            }
            
            
        }
    }


    .gens_four_content{
             background-color: rgba(251,207,192,0.2);
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_four_content_info{
             width:1200px;
             margin:auto;
             .gens_four_content_tip{
                 .gens_four_content_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_four_content_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }

            }
            .gens_four_detail{
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                width:90%;
                margin-bottom:30px;
                 .gens_four_detail_left{
                     width:66.66%;
                     display: flex;
                     justify-content: flex-start;
                     flex-direction: row;
                     flex-wrap: wrap;
                     .gens_four_item{
                         width:33.33%;
                         .gantanhao{
                             color: #cb3439;
                             font-size: 16px;
                             line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                         }
                         .four_detail_tip{
                             color: #cb3439;
                             font-size: 16px;
                             line-height: 24px;
                            font-style: normal;
                            font-weight: 400;
                         }
                     }
                }
                .gend_four_detail_right{
                    width: 33.33333333%;
                    text-align: center;
                    display: flex;
                    justify-content: flex-start;
                    margin-top:-90px;
                    .four_detai_img{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        img{
                            height: auto;
                            max-width: 100%;
                            vertical-align: middle;
                            width:150px;
                        }
                        .right_death{
                            text-align: center;
                            color: #cb3439;
                            font-size: 28px;
                            font-style: normal;
                            font-weight: 700;
                            text-transform: none;
                            .gantanhao{
                                color: #cb3439;
                                font-size: 28px;
                                font-style: normal;
                                font-weight: 700;
                                text-transform: none;
                            }
                        }
                    }
                }
            }
           
         }
    }


    .gens_killer_content{
        background-color: #fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
        
         .gens_killer_content_info{
             width:1200px;
             margin:auto;
             .gens_killer_content_tip{
                 .gens_killer_content_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_killer_content_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }

            }

            .killer_content{
                width:90%;
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                text-align: center;
                margin-bottom: 20px;
                .killer_content_item{
                    width: 50%;
                    margin-right: 40px;;
                    &:last-child{
                        margin-right: 0;
                    }
                    .killer_img{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                        margin-bottom:30px;
                        img{
                            height: auto;
                            max-width: 100%;
                            width:800px;
                        }
                    }
                    .killer_img_one,.killer_img_two{
                        opacity: 0 ;
                    }
                    
                    .killer_tip{
                        text-align: center;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 600;
                        text-transform: none;
                        color: #cb3439;
                        line-height: 1.304347826086957em;
                        letter-spacing: 1px;
                    }
                    .killer_content{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        text-align: center;
                        letter-spacing: 0.07em !important;
                        display: flex;
                        width:100%;
                        justify-content: center;
                    }

                }
            }
         }
    }
     
    .gens_transparent_bk{
        height: 400px;
        background-image: url(../../assets/images/monogenicdisease/baby-feet.jpg);
        background-position: 50% 224px;
        position: static;
        padding: 0;
        background-repeat: no-repeat;
        background-color: transparent;
        background-position: center 0;
        background-attachment: fixed;
        overflow: hidden;
         .gens_transparent_bk_content{
             padding-top: 150px;
             padding-bottom: 150px;
             .gens_transparent_bk_tip{
                 text-align: center;
                 color: #ffffff;
                 font-size: 16px;
                line-height: 24px;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
                 .bk_number{
                     font-size: .5em;
                    vertical-align: super;
                 }
             }
             .gens_transparent_bk_c{
                 margin-top:24px;
                color: #fff;
                font-size: 30px;
                line-height: 1.25em;
                font-style: normal;
                font-weight: 400;
                letter-spacing: 0.07em !important;
             }
         }
    }

     .gens_testing_info{
        background-color:#fff;
        .gens_testing_info_show{
            .info_show_text{
                display: block;
                position: relative;
                margin: 0;
                padding: 39px 0 15px;
                color: rgb(203, 52, 57);
                font-size: 19px;
                font-weight: 600;
                line-height: 22px;
                cursor: pointer;
                z-index: 90;
                text-align: center;
            }
            .info_show_text_icon{
                display: inline-block;
                font: 14px/1 FontAwesome;
                font-size: inherit;
                text-rendering: auto;
                -webkit-font-smoothing: antialiased;
                text-align: center;
                cursor: pointer;
                .xiala{
                    color: rgb(203, 52, 57);
                    font-size:16px;
                }
                .xiala:hover{
                     color:rgb(230,153, 178) !important;
                }
                


            }

            .info_show_text:hover{
                color:rgb(230,153, 178) !important;
            }
            .info_show_text:hover .xiala{
                color:rgb(230,153, 178) !important;
            }
            .gens_testing_info_show:hover{
                color:rgb(230,153, 178) !important;
            }


        }

        .gens_testing_detail{
             width:1200px;
             margin:auto;
             margin-bottom:30px;
            .gens_testing_detail_content{
                display:flex;
                justify-content: space-between;
                flex-direction: row;
                .gens_testing_detail_c_item{
                    text-align: left;
                    ol{
                        font-size: 14px;
                        line-height: 27px;
                        letter-spacing: .07em!important;
                        color: #3b3b3b;
                        font-weight: 400;
                    }
                    li{
                        display: list-item;
                        text-align: -webkit-match-parent;
                    }
                }
            }
        }
        
    }


     .gens_example_analysis{
         background-color:#fff;
         padding-top: 60px;
         padding-bottom: 30px;
         text-align: left;
         .gens_example_analysis_info{
             width:1200px;
             margin:auto;
             .gens_example_analysis_info_tip{
                 .gens_example_analysis_text{
                    color: #e699b2;
                     font-size: 28px;
                    font-style: normal;
                    font-weight: 700;
                    text-transform: none;
                    line-height: 1.384615384615385em;
                    letter-spacing: 1px;
                 }
                 .gens_example_analysis_line{
                     margin-top: 10px;
                    margin-bottom: 30px;
                    background-color: #e699b2;
                    width: 250px;
                    height: 2px;
                    position: relative;
                    display: block;
                 }
             }

             .gens_analysis_content{
                 display: flex;
                 flex-direction: row;

                 .gens_analysis_left{
                     width:50%;
                     .gens_example_single{
                         width:900px;
                        font-size: 18px;
                        color: #ffffff;
                        font-weight: bold;
                        background-color: #e699b2;
                        line-height: 24px;
                        font-style: normal;
                        letter-spacing: .07em!important;
                        margin-bottom:24px;

                    }
                    .gens_example_advice{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: .07em!important;
                        strong{
                            color: #cb3439;

                        }
                    }
                    .for_example{
                        margin-top:30px;
                        margin-bottom:30px;
                        padding: 14px 14px 14px 10px;
                        display:flex;
                        flex-direction: row;
                        border-left:4px solid #e699b2;
                        background-color: rgba(251,207,192,0.2);
                        width: 85%;
                        .yinhaos{
                            color: #e699b2;
                            font-size: 28px;
                            margin: 6px 0 0!important;
                        }
                        .for_example_content{
                            padding-left:40px;
                            font-size: 18px;
                            font-weight: 500;
                        }
                    }
                   
                 }
                 .gens_analysis_right{
                     width:40%;
                     margin-top: 30px;
                     margin-bottom: 30px;;
                     .gens_analysis_right_img{
                        display: inline-block;
                        vertical-align: top;
                        max-width: 100%;
                         img{
                            height: auto;
                            max-width: 100%;
                            width:800px;
                         }
                     }
                 }
             }
             
             
         }
     }

.opacity{
    clear: both;
    opacity: 1 !important;
}

.special_result{
    background-color: rgba(251,207,192,0.2);
  
}
    

}
.specialabstract_stip{
    padding:0 15px !important;
}
</style>

<style lang="scss">

.gens_results_right{
    .el-carousel__button{
        border-radius: 50% !important;
        width:12px !important;
        height: 12px !important;
    }
}
@-o-keyframes element-from-bottom{
    0%{-o-transform:translate(0,30%);opacity:0}
    100%{-o-transform:translate(0,0);opacity:1}
}
@-o-keyframes element-from-left{
    0%{
        -o-transform:translate(-20%,0);opacity:0}
    100%{
        -o-transform:translate(0,0);opacity:1}
}
</style>


// WEBPACK FOOTER //
// src/view/genedetection/monogenicdisease.vue